import React from 'react'

import { ISSUE_STATUS, REPORT } from '../../../../../helpers/constants'

import Style from './style'

const IssueStatus = (props) => {
  const { status, language } = props

  const StatusItem = (status) => {
    switch (status) {
      case ISSUE_STATUS.COMPLETED:
        return <div className='completed'>{REPORT.COMPLETED_STATUS[language]}</div>

      case ISSUE_STATUS.ON_GOING:
        return <div className='on-going'>{REPORT.ON_GOING_STATUS[language]}</div>

      case ISSUE_STATUS.WAITING:
      default:
        return <div className='waiting'>{REPORT.WAITING_STATUS[language]}</div>
    }
  }

  return (
    <Style>
      <StatusItem status={status} />
    </Style>
  )
}

export default IssueStatus
